import { Icon } from '@iconify/react';
import { ReactNode } from 'react';

import { Popover } from 'components/data-display/Popover';
import { TextArea } from 'components/data-entry/Input';
import { Button } from 'components/general/Button';

interface FeedbackPopoverProps {
  open: boolean;
  title: string;
  value: string;
  onChange: (v: string) => void;
  onCancel: () => void;
  onSubmit: () => void;
  loading?: boolean;
  placement?: 'bottomRight' | 'bottom' | 'top' | 'topRight' | 'right' | 'left';
  triggerContent: ReactNode; // the button/icon that opens the popover
}

export const FeedbackPopover = ({
  open,
  title,
  value,
  onChange,
  onCancel,
  onSubmit,
  loading,
  placement = 'left',
  triggerContent,
}: FeedbackPopoverProps) => {
  return (
    <Popover
      open={open}
      placement={placement}
      trigger={['click']}
      onOpenChange={(v) => {
        if (!v) onCancel();
      }}
      overlayStyle={{
        position: 'fixed',
      }}
      styles={{
        content: {
          padding: 0,
          borderRadius: 12,
        },
      }}
      content={
        <div className="w-[400px] max-w-[90vw] rounded-xl border border-gray-200 shadow-xl bg-white">
          <div className="flex items-center justify-between px-4 py-3">
            <div className="text-sm font-medium text-gray-900">{title}</div>
            <button
              aria-label="Close"
              className="text-gray-400 hover:text-gray-600 transition-colors"
              onClick={onCancel}
            >
              <Icon icon="radix-icons:cross-2" className="text-lg" />
            </button>
          </div>
          <div className="px-4 pb-4">
            <div className="text-xs text-gray-500 mb-3">
              We&apos;ll use this information to improve our AI responses.
            </div>
            <div className="w-[368px] h-[50px] mb-4">
              <TextArea
                rows={2}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder="What did you like or dislike about the AI output?"
                className="resize-none border-gray-200 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 w-full h-full"
              />
            </div>
            <div className="flex justify-end">
              <Button type="primary" loading={!!loading} onClick={onSubmit}>
                Submit feedback
              </Button>
            </div>
          </div>
        </div>
      }
    >
      {triggerContent}
    </Popover>
  );
};

export default FeedbackPopover;
